import { render } from "./ChoosePaymentMethodModal.vue?vue&type=template&id=9126c160"
import script from "./ChoosePaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./ChoosePaymentMethodModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__